var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3.5H20.5C21.0523 3.5 21.5 3.94772 21.5 4.5V20.5C21.5 21.0523 21.0523 21.5 20.5 21.5H4.5C3.94772 21.5 3.5 21.0523 3.5 20.5V4.5C3.5 3.94772 3.94772 3.5 4.5 3.5ZM11.5026 16.5L18.5737 9.42893L17.1595 8.01472L11.5026 13.6716L8.67421 10.8431L7.25999 12.2574L11.5026 16.5Z",
    fill: "#4DB748"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/CheckedIcon.d2b3c431b0539b21b1c2700b8fa0f4cc.svg";
export { ForwardRef as ReactComponent };